import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";

export const StyledServiceContractDetailsContainer = styled(Grid)({
  padding: "16px 0px 32px 0px",
});

export const StyledServiceContractDetailsSubheader = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.text.secondary,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "22.88px",
    letterSpacing: "0.17px",
  }),
);
